module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payroll/PayrollView.html -->\n<div class="row wrapper border-bottom white-bg page-heading">\n    <div class="col-xs-12">\n        <h2>Payroll for '+
((__t=( period ))==null?'':_.escape(__t))+
'</h2>\n    </div>\n</div>\n\n<div class="wrapper wrapper-content" id="payroll-view">\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h5>\n                        <a href="#payroll/history">\n                            Payroll History</a> / '+
((__t=( period ))==null?'':_.escape(__t))+
'\n                    </h5>\n                </div>\n                <div class="ibox-content">\n                    <div class="row">\n                        <div class="col-xs-12">\n                            <div id="content" class="wrapper wrapper-content">\n                                <div id="loader" class="loader loader-payroll">\n                                    '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payroll/PayrollView.html
// module id = 769
// module chunks = 1